'use strict';
import { IHttpService, IQService } from 'angular';
import { IBitUrlBuilder } from '../bitUrlBuilder/bitUrlBuilder.factory';

export type IArtistService = ReturnType<typeof artistService>;

/* @ngInject */
export function artistService(
  $http: IHttpService,
  $q: IQService,
  CacheFactory,
  bitUrlBuilder: IBitUrlBuilder,
) {
  const cache = CacheFactory('artistValidate', { maxAge: 60 * 2 });

  function getArtist(name) {
    return $http
      .get<any>(bitUrlBuilder.buildArtistUrl(name), { cache })
      .then(({ data }) => {
        const { errors, id } = data;
        if (errors) {
          return $q.reject(errors);
        }
        if (!id) {
          return $q.reject(['Unknown Artist']);
        }
        return data;
      });
  }

  function validateArtist(name) {
    return getArtist(name).then((data) => {
      const { id } = data;
      if (!id) {
        return $q.reject(['Unknown Artist']);
      }
    });
  }

  return {
    validateArtist,
    getArtist,
  };
}
